import { ConnectedPosition, OverlayModule } from "@angular/cdk/overlay";
import { NgComponentOutlet, NgTemplateOutlet } from "@angular/common";
import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  Type,
} from "@angular/core";
import {
  DEFAULT_POPOVER_POSITIONS,
  PopoverTrigger,
} from "./popover.model";

@Component({
  selector: "app-popover",
  standalone: true,
  imports: [OverlayModule, NgTemplateOutlet, NgComponentOutlet],
  templateUrl: "./popover.component.html",
  styleUrl: "./popover.component.scss",
})
export class PopoverComponent {
  @Input() trigger: PopoverTrigger = "click";
  @Input() content?: string;
  @Input() bodyComponent?: Type<unknown>;
  @Input() bodyInputs?: Record<string, unknown>;
  @Input() positions: ConnectedPosition[] = DEFAULT_POPOVER_POSITIONS;
  @Input() panelClass = "";
  @Input() disabled = false;

  @ContentChild("popoverBody") bodyTemplate?: TemplateRef<unknown>;

  isOpen = false;
  private hoverCloseTimer: ReturnType<typeof setTimeout> | null = null;

  get hasCustomBody(): boolean {
    return !!this.bodyTemplate || !!this.bodyComponent;
  }

  get panelClasses(): string[] {
    const classes = ["app-popover-panel"];

    if (this.panelClass) {
      classes.push(this.panelClass);
    }

    return classes;
  }

  onTriggerClick(event: MouseEvent): void {
    if (this.disabled || this.trigger !== "click") {
      return;
    }

    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  onTriggerMouseEnter(): void {
    if (this.disabled || this.trigger !== "hover") {
      return;
    }

    this.clearHoverTimer();
    this.isOpen = true;
  }

  onTriggerMouseLeave(): void {
    if (this.trigger !== "hover") {
      return;
    }

    this.scheduleHoverClose();
  }

  onPanelMouseEnter(): void {
    if (this.trigger !== "hover") {
      return;
    }

    this.clearHoverTimer();
  }

  onPanelMouseLeave(): void {
    if (this.trigger !== "hover") {
      return;
    }

    this.scheduleHoverClose();
  }

  close(): void {
    this.isOpen = false;
    this.clearHoverTimer();
  }

  private scheduleHoverClose(): void {
    this.clearHoverTimer();
    this.hoverCloseTimer = setTimeout(() => this.close(), 120);
  }

  private clearHoverTimer(): void {
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
  }
}
